export var getWebStorageKey = function (storageKey) {
    return ['WebStorage', storageKey];
};
//# sourceMappingURL=getWebStorageKey.js.map